export default [
  {
    name: "Desarrollo Web",
    score: 95,
    description:
      "Creación de software basado en la web como intranet, sistema de tickets, reportes financieros, reportes de asistencia, evaluaciones de competencias, integraciones con terceros, entre otros",
    technologies: [
      "Laravel",
      "Vue",
      "TailwindCSS",
      "MySQL/PostgreSQL",
      "Axios",
      "Git",
      "PHPUnit",
    ],
    level: "Avanzado",
  },
  {
    name: "Maquetado Web",
    score: 75,
    description:
      "Maquetar sitios web basado en imagen completa o mockups para PerfectPixel",
    technologies: [
      "TailwindCSS",
      "SASS",
      "CSS3",
      "HTML5",
      "Javascript",
      "Vue",
      "Vuex",
      "Vue-Router",
    ],
    level: "Medio",
  },
  {
    name: "Administrar Servidor",
    score: 55,
    description:
      "Admistrar servidor de forma 'básica' para el despliegue de aplicaciones como manejo de herramientas para el desarrollo local y producción",
    technologies: [
      "Docker",
      "Nginx",
      "AWS EC2",
      "DigitalOcean",
      "AWS Amplify",
      "AWS Route 53",
    ],
    level: "básico",
  },
];
